import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  pageInfo: {
    page: 1,
    totalPage: 2,
    limit: 12
  },

  list: [], // 1:1 문의 리스트
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
